// extracted by mini-css-extract-plugin
module.exports = {"button":"_1FCssP6rL7_services-landings","extraClickZone":"_1YgCdvadZh_services-landings"};